export const ITEMS_PER_PAGE = 10;

export const SUPPLY_ORDER_ARTICLE_CHIP_CONFIG = {
  maxLabelLength: 50,
  fontSize: 11,
};

export const SOURCE_TYPES = {
  PROVIDER: 'provider',
  WAREHOUSE: 'warehouse',
};

export const SOURCE_TYPE_LABELS = {
  provider: 'Proveedor',
  warehouse: 'Depósito',
};

export const SUPPLY_ORDER_STATUSES = {
  DRAFT: 'draft',
  ISSUED: 'issued',
  SENT: 'sent',
  ACKNOWLEDGED: 'acknowledged',
  PARTIALLY_RECEIVED: 'partially_received',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
  CLOSED: 'closed',
};

export const SUPPLY_ORDER_STATUS_LABELS = {
  draft: 'Borrador',
  issued: 'Emitida',
  sent: 'Enviada',
  acknowledged: 'Confirmada',
  partially_received: 'Parcialmente recibida',
  received: 'Recibida',
  cancelled: 'Cancelada',
  closed: 'Cerrada',
};

export const SUPPLY_ORDER_STATUS_COLORS = {
  draft: 'default',
  issued: 'info',
  sent: 'primary',
  acknowledged: 'secondary',
  partially_received: 'warning',
  received: 'success',
  cancelled: 'error',
  closed: 'default',
};

export const TERMINAL_STATUSES = [
  SUPPLY_ORDER_STATUSES.RECEIVED,
  SUPPLY_ORDER_STATUSES.CANCELLED,
  SUPPLY_ORDER_STATUSES.CLOSED,
];

export const EDITABLE_STATUSES = [SUPPLY_ORDER_STATUSES.DRAFT];

export const RECEIVABLE_STATUSES = [
  SUPPLY_ORDER_STATUSES.ISSUED,
  SUPPLY_ORDER_STATUSES.SENT,
  SUPPLY_ORDER_STATUSES.ACKNOWLEDGED,
  SUPPLY_ORDER_STATUSES.PARTIALLY_RECEIVED,
];

export const PRINTABLE_STATUSES = [
  SUPPLY_ORDER_STATUSES.ISSUED,
  SUPPLY_ORDER_STATUSES.SENT,
  SUPPLY_ORDER_STATUSES.ACKNOWLEDGED,
  SUPPLY_ORDER_STATUSES.PARTIALLY_RECEIVED,
  SUPPLY_ORDER_STATUSES.RECEIVED,
  SUPPLY_ORDER_STATUSES.CLOSED,
];

export const INITIAL_SUPPLY_ORDER_STATE = {
  destination_kind: '',
  uuid_project: '',
  internal_reason: '',
  internal_reason_detail: '',
  has_technical_origins: false,
  is_consolidated: false,
  source_type: SOURCE_TYPES.PROVIDER,
  uuid_provider_legal_entity: '',
  uuid_source_warehouse: '',
  uuid_destination_warehouse: '',
  required_at: '',
  provider_delivery_commitment_at: '',
  delivery_place: '',
  delivery_contact_name: '',
  delivery_contact_phone: '',
  conditions: '',
  observations: '',
  materials: [],
};

export const getInitialSupplyOrderState = () => ({
  ...INITIAL_SUPPLY_ORDER_STATE,
  materials: [],
});

export const INITIAL_FILTERS = {
  uuid_project: '',
  query: '',
  status: '',
  source_type: SOURCE_TYPES.PROVIDER,
  uuid_provider_legal_entity: '',
  uuid_destination_warehouse: '',
  date_from: '',
  date_to: '',
};

export const SUPPLY_ORDER_PRICE_TEXTS = {
  header: 'Precio unit. ARS',
  tooltip: 'Precio final unitario en pesos, con IVA incluido',
  selectGroup: 'Seleccionar grupo completo',
  leftToOrder: 'Por pedir',
  lineTotal: 'Total ARS',
  orderTotal: 'Total de la orden',
  pendingPrice: 'Precio pendiente',
};


export const SUPPLY_ORDER_TABLE_TEXTS = {
  articles: 'Artículos',
};

export const RECEIVE_VALUATION_TEXTS = {
  title: 'Valorizar stock sin valoración',
  confirm: 'Valorizar y recibir',
  message: (orderCode) =>
    'En el depósito hay stock de estos materiales que todavía no tiene valoración. ' +
    `Al confirmar, ese stock se valoriza con el precio de esta orden (${orderCode}) y queda ` +
    'como apertura aprobada en Valoración de materiales, con la orden como fuente y referencia.',
  line: (item, price) =>
    `${item.article_name}: ${item.unvalued_quantity} sin valorar a ${price} por unidad`,
  openedLine: (item) =>
    `${item.article_name}: ${item.unvalued_quantity} sin valorar; ya tiene apertura, ` +
    'se valoriza desde Valoración de materiales',
};

export const SUPPLY_ORDER_MATERIAL_TEXTS = {
  title: 'Artículos',
  search: 'Agregar artículo',
  searchPlaceholder: 'Código, código externo o nombre',
  searchError: 'Error al buscar artículos',
  searching: 'Buscando...',
  noResults: 'Sin resultados',
  minLength: (count) => `Escribí al menos ${count} caracteres`,
  consolidatedOnly:
    'Una compra consolidada solo lleva materiales de pedidos técnicos. Para reponer otros ' +
    'materiales, creá una orden manual.',
};

export const SUPPLY_ORDER_FORM_TEXTS = {
  sourceType: 'Tipo de origen',
  provider: 'Proveedor',
  providerOptional: 'Proveedor (opcional en borrador)',
  sourceWarehouse: 'Depósito origen',
  destinationWarehouse: 'Depósito destino (recepción)',
  requiredAt: 'Fecha requerida',
  commitment: 'Compromiso proveedor',
  deliveryPlace: 'Lugar de entrega',
  deliveryContact: 'Contacto de entrega',
  deliveryPhone: 'Teléfono de contacto',
  conditions: 'Condiciones',
  observations: 'Observaciones',
  searchProvider: 'Buscar proveedor',
  searchWarehouse: 'Buscar depósito',
};

export const SUPPLY_ORDER_LIST_TEXTS = {
  project: 'Proyecto',
  generalStock: 'Stock general',
  multipleOrders: (count) => `${count} pedidos`,
  number: 'Número',
  sourceType: 'Tipo origen',
  source: 'Origen',
  destination: 'Destino',
  date: 'Fecha',
  commitment: 'Compromiso',
  status: 'Estado',
  externalOrder: 'Pedido técnico',
  actions: 'Acciones',
  view: 'Ver detalle',
  edit: 'Editar borrador',
  empty: 'No se encontraron órdenes de abastecimiento',
};

export const SUPPLY_ORDER_FILTER_TEXTS = {
  project: 'Proyecto',
  searchProject: 'Buscar proyecto',
  search: 'Buscar',
  searchPlaceholder: 'Código, proveedor, depósito...',
  status: 'Estado',
  sourceType: 'Origen',
  provider: 'Proveedor',
  destination: 'Destino',
  dateFrom: 'Desde',
  dateTo: 'Hasta',
  all: 'Todos',
  searchProvider: 'Buscar proveedor',
  searchWarehouse: 'Buscar depósito',
  clear: 'Limpiar filtros',
};

export const SUPPLY_ORDER_ITEM_TABLE_TEXTS = {
  article: 'Artículo',
  quantity: 'Cantidad',
  requested: 'Solicitada',
  received: 'Recibida',
  pending: 'Pendiente',
  cancelled: 'Cancelada',
  closedDifference: 'Cerrada c/dif.',
  receiveNow: 'Recibir ahora',
  provider: 'Proveedor',
  commitment: 'Compromiso',
  source: 'Origen',
  providerOrWarehouse: 'Proveedor / Depósito',
  select: 'Seleccionar',
  searchProvider: 'Buscar proveedor',
  searchWarehouse: 'Buscar depósito',
  empty: 'Sin artículos',
  emptyPending: 'No hay artículos pendientes de recepción',
  emptyMissing: 'No hay artículos con cantidades faltantes',
};

export const SUPPLY_ORDER_RECEIPT_TABLE_TEXTS = {
  code: 'Código',
  date: 'Fecha',
  document: 'Documento',
  status: 'Estado',
  items: 'Artículos recibidos',
  unitSuffix: 'u.',
};

export const RECEIVE_SUPPLY_ORDER_FORM_TEXTS = {
  notes: 'Notas',
};

export const SUPPLY_ORDER_ACTION_TEXTS = {
  reason: 'Motivo',
};

export const SUPPLY_ORDER_RECEIPT_STATUS_CONFIG = {
  draft: { label: 'Borrador', color: 'default' },
  confirmed: { label: 'Confirmada', color: 'success' },
  cancelled: { label: 'Cancelada', color: 'error' },
  reversed: { label: 'Revertida', color: 'warning' },
};

export const SUPPLY_ORDER_HELP_TEXTS = {
  issue:
    'Asigná proveedor, precio y compromiso por artículo. ' +
    'Si hay distintas combinaciones, se generarán varias órdenes emitidas.',
  draftFromTechnicalOrder:
    'Se genera un borrador con las cantidades indicadas. ' +
    'Compras asigna proveedor, precio y compromiso por material al emitir la orden.',
};

export const RECEIPT_ALLOCATION_TEXTS = {
  title: 'Distribuir el remito por pedido',
  article: 'Material',
  total: 'Total aceptado',
  propose: 'Proponer reparto',
  info:
    'El reparto prioriza la fecha de necesidad y luego la antigüedad del pedido. ' +
    'Revisá y ajustá cada renglón antes de confirmar. ' +
    'El total debe ser igual o menor al pendiente del material.',
};
